<template>
  <div>
    <input type="checkbox" id="menu_switch" style="display: none;">
    <div class="logo_box">
      <label for="menu_switch">
        <div class="nav_click" :class="{'active': nav_flag}" @click="menuClick()">
          <i></i><i></i><i></i>
        </div>
      </label>
      <div class="logo_block">
        <router-link to="/"><img src="@/assets/toplink_logo_white.png" /></router-link>
      </div>
      <div class="header_title_block">
        <router-link to="/member/profile">Member Center</router-link>
      </div>
    </div>
    <div class="nav_bar" :class="{'open': nav_flag, 'close': !nav_flag}">
      <div>
        <div class="member_name">
          <img src="@/assets/member_m.png" :alt="member_info.name">
          <p>Hi, {{member_info.name}} 歡迎光臨</p>
        </div>
        <nav id="side_menu_list">
          <ul>
            <li>
              <router-link to="/member/profile" @click.native="menuClick()">上聯會員卡</router-link></li>
            <li><a :class="{'active': isActive==1}" href="javascript: void(0);" @click="toggle_nav(1)">會員中心<i class="fa fa-chevron-down"></i></a>
              <ul :class="{'active': isActive==1}">
                <li><router-link to="/member/profile_edit" @click.native="menuClick()">會員資料管理</router-link></li>
                <li><router-link @click.native="menuClick()" to="/member/password_edit" >修改密碼</router-link></li>
              </ul>
            </li>
            <li><a :class="{'active': isActive==2}" href="javascript: void(0);" @click="toggle_nav(2)">活動紀錄<i class="fa fa-chevron-down" ></i></a>
              <ul :class="{'active': isActive==2}">
                <li><router-link to="/member/ticket" @click.native="menuClick()">報名紀錄</router-link></li>
              </ul>
            </li>
            <li>
              <!-- <router-link to="/member/profile" @click.native="menuClick()">回首頁</router-link> -->
            </li>
          </ul>
        </nav>
      </div>
      <div class="logout">
        <hr>
        <a @click="logout()"><i class="fa fa-power-off"></i>  登出</a>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'memberHeader',
  data() {
    return {
      member_info: {},
      isActive: 0,
      nav_flag: false,
    }
  },
  created() {
    this.$cookies.isKey('member') ? this.member_info = this.$cookies.get('member') : this.$router.push('/')
  },
  methods: {
    menuClick(){
      this.nav_flag = !this.nav_flag  
    },
    toggle_nav(num){
      num == this.isActive ? this.isActive = 0 : this.isActive = num 
    },
    logout(){
      this.$cookies.remove('member')
      this.$router.push('/')
    },
  },
}
</script>
<style>
  .logo_box{
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
  }
  .logo_block{
    width: 300px;
    background: #275a8a;
    text-align: center;
  }
  .logo_block img{
    margin:9px 0 6px 0;
    max-width: 85%;
    height: 57px;
  }
  .header_title_block{
    width: calc(100vw - 300px);
    text-align: center;
    font-size: 30px;
    font-family: 'serif' ;
    font-style: italic;
    background: #313131;
    color: #ffffff;
  }
  .header_title_block a{
    display: inline-block;
    margin-top: 18px;
    color: #ffffff;
  }
  .nav_click{
    display: none;
    width: 50px;
    height: 50px;
    margin: 0 0 5px 5px;
    cursor: pointer;
    position: absolute;
    top: 20px;
    left: 0;
  }
  .nav_click i{
    transition: 0.2s;
    position: absolute;
    display: block;
    margin: 0 6px;
    width: 38px;
    height: 5px;
    background-color: #FFFFFF;
    border-radius: 4px;
  }
  .nav_click i:nth-child(1){top: 0;}
  .nav_click i:nth-child(2){top: 15px; left: 0;}
  .nav_click i:nth-child(3){top: 30px;}
  .nav_click.active i:nth-child(1) { top: 20px; transform: rotate(-45deg); }
  .nav_click.active i:nth-child(2) { width: 0; left: 25px; }
  .nav_click.active i:nth-child(3) { top: 20px; transform: rotate(45deg); }

  .nav_bar{
    position: fixed;
    height: calc(100vh - 76px);
    width: 300px;
    bottom: 0;
    left: 0;
    background: #313131;
    overflow: auto;
    z-index: 30;
  }
  .nav_bar>div:nth-child(1){
    height: calc(100vh - 150px);
    overflow: auto;
  }
  .member_name{
    text-align: center;
    padding: 15px 10px;
    background-color: #353c50;
  }
  .member_name p{
    color: white;
    margin-bottom: 0;
  }
  /* 導覽列 */
  nav ul{
    padding: 0;
    margin: 0;
  }
  nav>ul>li{
    font-size: 1rem;
    line-height: 1.5
  }
  nav>ul>li a,
  .logout a{
    color: #aaa;
    display: block;
    padding: 23px;
    cursor: pointer;
  }
  nav>ul>li:not(:last-child)>a{
    border-bottom: 1px solid #545454;
    display: flex;
    justify-content: space-between;
    align-content: center
  }
  nav>ul>li>a>i{
    color: #61df37;
    font-size: 16px;
    transition: .3s;
  }
  nav>ul>li>a.active>i{ 
    transform: rotate(180deg);
  }
  nav>ul>li>a>i.fa-chevron-down:before{
    vertical-align: middle;
  }
  .logout hr {
    margin: 0 20px;
    border-color: #545454;
  }
  .logout{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    cursor: pointer;
    margin-top: 2px;
    z-index: 30;
  }
  .logout a{
    font-size: 1.3rem;
    transition: all .3s;
  }
  .logout a:hover{
    background: #262626;
    color: #fc0000c4;
  } 
  /* 第二層 */
  nav>ul>li>ul{
    transition: all 1s;
    max-height: 0;
    background: #262626;
    overflow: hidden;
    transition: 1s;
  }
  nav>ul>li>ul.active{
    max-height: 142px;
  }
  nav>ul>li>ul>li{
    padding-left: 20px;
    transition: all .3s;
  }
  nav>ul>li>ul>li:hover{
    background: #2b2b2b;
    
  }
  nav>ul>li>ul>li:hover a {
    color: #fff;
  }
  .router-link-active{ color: #25EAA8; font-weight: bold;}
  .router-link-active:hover{color: #25EAA8; }
  @media(max-width: 992px){
    .logo_block{
      width: 200px;
    }
    .header_title_block{
      width: 100vw;
    }
    .nav_bar{
      width: 200px;
    }
    nav>ul>li>ul>li{
      padding-left: 15px;
    }
  }

  @media(max-width: 768px){
    .nav_click{
      display: inline-block;
      background: #313131
    }
    .logo_box{
      background: #313131;
    }
    .logo_block{
      width: 100vw;
      background: #313131;
    }
    .header_title_block{
      display: none;
    }
    .nav_bar{
      left: -100%;
      transition: ease-in-out .3s;
    }
    .nav_bar.open{ 
      left: 0;
      width: 100%;
    }
    .nav_bar.close{ left: -100%;}
  }
</style>